import Modal from '../helpers/Modal';

export default class SearchModal {
    constructor(root) {
        this.root = root;
        this.input = this.root.querySelector('.js-search-modal-field');

        this.modal = new Modal(this.root, (dataset) => {
            document.querySelector('.js-modal-container').classList.add('--blue-bg');
            this.input.focus();
        }, (dataset) => {
            document.querySelector('.js-modal-container').classList.remove('--blue-bg');
        }, {show_close: true});
    }
}
